import Vue from "vue";
import router from "@/router";
import { checkResponse, clearSession } from "@/helpers/store";

const state = {
  user: {
    login: null,
    language: null,
    token: null,
    tokenid: null,
    userid: null
  },
  config: null,
  error: null,
  loading: false,
  base: {
    url: null,
    label: null
  },
  auth: {
    url: null,
    servers: null,
    sections: null,
    bases: null
  },
  externalAuth: false
};

const mutations = {
  setUser: (state, payload) => (state.user = payload),
  setConfig: (state, payload) => (state.config = payload),
  setError: (state, payload) => (state.error = payload),
  setLoading: (state, payload) => (state.loading = payload),
  setBase: (state, payload) => (state.base = payload),
  setAuthUrl: (state, payload) => (state.auth.url = payload),
  setAuthServers: (state, payload) => (state.auth.servers = payload),
  setAuthSections: (state, payload) => (state.auth.sections = payload),
  setAuthBases: (state, payload) => {
    if (payload) {
      const section = [
        ...state.auth.sections.filter(item => item.section === payload)
      ];
      payload = section[0].bases;
    }
    state.auth.bases = payload;
  },
  setExternalAuth: (state, payload) => (state.externalAuth = payload)
};

const actions = {
  async getConfig({ commit }) {
    try {
      commit("setFullPageLoading", true);

      /* eslint-disable */
      const response = await Vue.axios.get(__webpack_public_path__ + "config.json");
      const config = response.data;

      const checkDebug = Vue.localStorage.get('wb-debug');
      if (checkDebug !== "1") {
        const regex = new RegExp("^https?:\/\/localhost");
        config.connections = [
          ...config.connections.filter(item => !regex.test(item.url))
        ];
      }
      commit("setConfig", config);
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async signIn({ commit, state }, { login, password, language, connection, url, label, start, server, section, base, external }) {
    try {
      commit("setFullPageLoading", true);
  
      commit("setBase", { url, label });

      const response = await Vue.axios.post(state.base.url, {
        cmd: "auth",
        params: {
          login: login,
          passwd: password,
          lang: language === "ua" ? "uk" : language
        }
      });
  
      const result = checkResponse(commit, response);
      if (result == 'ok') {
        const auth = response.data;
        const token = auth.token;
        const tokenid = auth.tokenid;
        const userid = auth.userid;
  
        commit("setUser", { login, language, token, tokenid, userid });
  
        const wbConnection = { login, language, connection, server, section, base, external};
        Vue.localStorage.set("wb-connection", JSON.stringify(wbConnection));            
  
        const wbAuth = { url, label, start, token, tokenid, userid };
        Vue.localStorage.set("wb-auth", JSON.stringify(wbAuth));

        router.push('/');
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async signOut({ commit, state }) {
    try {
      commit("setFullPageLoading", true);
  
      const response = await Vue.axios.post(state.base.url, {
        cmd: "logout"
      }, {
        headers: {
          Authorization: `{"token":["${state.user.token}","${state.user.tokenid}"]}`
        } 
      });
  
      await clearSession();

    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getServers({ commit, state }) {
    try {
      commit("setFullPageLoading", true);
  
      const response = await Vue.axios.post(state.auth.url, {
        cmd: "getServers",
        type: "byt"
      });
  
      const result = checkResponse(commit, response);
      if (result == 'ok') {
        commit("setAuthServers", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getSections({ commit, state }, { serverid }) {
    try {
      commit("setFullPageLoading", true);
  
      const response = await Vue.axios.post(state.auth.url, {
        cmd: "getSections",
        type: "byt",
        serverid: `${serverid}`
      });

      const result = checkResponse(commit, response);
      if (result == 'ok') {
        commit("setAuthSections", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  user: state => state.user,
  isUserSignin: state => !!state.user.login && 
                         !!state.user.language && 
                         !!state.user.token && 
                         !!state.user.tokenid && 
                         !!state.user.userid,
  isBasePresent: state => !!state.base.url &&
                          !!state.base.label,
  config: state => state.config,
  error: state => state.error,
  loading: state => state.loading,
  base: state => state.base,
  authServers: state => state.auth.servers,
  authSections: state => state.auth.sections,
  authBases: state => state.auth.bases,
  externalAuth: state => state.externalAuth
};

export default { state, mutations, actions, getters };
